import script from "./indexH5.vue?vue&type=script&setup=true&lang=js"
export * from "./indexH5.vue?vue&type=script&setup=true&lang=js"

import "./indexH5.vue?vue&type=style&index=0&id=3a2e0ab2&lang=less"

const __exports__ = script;

export default __exports__